export const formatBountyValue = (bountyValue: number, options: Intl.NumberFormatOptions = {}) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    notation: "compact",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...options,
  }).format(bountyValue);
};

export const backToNumber = (value: string) => {
  const cleaned = value.replace(/[$,]/g, "");
  const number = Number(cleaned);
  return isNaN(number) ? 0 : number;
};
